import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "onImageUpload", "children", "minImageHeight", "minImageWidth"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { ThumbnailUploader } from '../../cropper/components/ThumbnailUploader';
import { useCallback } from 'react';
import { useSetPlaylistThumbnail } from '../savedItemsQueries';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import Raven from 'raven-js';
import I18n from 'I18n';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIFlex from 'UIComponents/layout/UIFlex';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import produce from 'immer';
import { useHasScope } from '../../accounts/accountsQueries';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HAS_CLOSED_PLAYLIST_THUMBNAIL_DISCLAIMER_LOCALSTORAGE_KEY = 'academy:hasClosedPlaylistThumbnailDisclaimer';
export const useClosedPlaylistThumbnailDisclaimer = create()(persist(set => ({
  hasClosedPlaylistThumbnailDisclaimer: false,
  setHasClosedPlaylistThumbnailDisclaimer: value => set(produce(state => {
    state.hasClosedPlaylistThumbnailDisclaimer = value;
  }))
}), {
  name: HAS_CLOSED_PLAYLIST_THUMBNAIL_DISCLAIMER_LOCALSTORAGE_KEY
}));
export const UploadPlaylistThumbnailButton = _ref => {
  let {
      playlistId,
      onImageUpload,
      children,
      minImageHeight,
      minImageWidth
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [setPlaylistThumbnail] = useSetPlaylistThumbnail(playlistId);
  const {
    hasClosedPlaylistThumbnailDisclaimer,
    setHasClosedPlaylistThumbnailDisclaimer
  } = useClosedPlaylistThumbnailDisclaimer();
  const {
    hasScope: canUploadImage
  } = useHasScope('file-manager-write');
  const handleClick = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'upload-playlist-thumbnail-click',
      playlistId
    });
  };
  const handleDisclaimerClose = () => {
    setHasClosedPlaylistThumbnailDisclaimer(true);
    UsageTracker.track('playlistInteraction', {
      action: 'upload-playlist-thumbnail-disclaimer-close-click'
    });
  };
  const handleImageLoad = useCallback((standardPreviewImage, reducedPreviewImage) => {
    if (onImageUpload) onImageUpload();
    setPlaylistThumbnail(standardPreviewImage, reducedPreviewImage).then(() => {
      FloatingAlertStore.addAlert({
        type: 'success',
        message: I18n.text('learningCenter.cropper.uploadSuccess')
      });
    }).catch(error => {
      Raven.captureException(error);
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: I18n.text('learningCenter.cropper.uploadError')
      });
    });
  }, [onImageUpload, setPlaylistThumbnail]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: canUploadImage ? null : I18n.text('learningCenter.playlists.noThumbnailUploadPermission'),
    children: /*#__PURE__*/_jsx(ThumbnailUploader, Object.assign({
      description: /*#__PURE__*/_jsxs(UIFlex, {
        className: "m-bottom-5",
        direction: "column",
        gap: 12,
        children: [/*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.thumbnailModalDescription"
          })
        }), !hasClosedPlaylistThumbnailDisclaimer && /*#__PURE__*/_jsx(UIAlert, {
          closeable: true,
          onClose: handleDisclaimerClose,
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.thumbnailModalDisclaimer"
          })
        })]
      }),
      descriptionReduced: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.thumbnailModalDescriptionReduced"
      }),
      descriptionStandard: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.thumbnailModalDescriptionStandard"
      }),
      disabled: !canUploadImage,
      minImageHeight: minImageHeight,
      minImageWidth: minImageWidth,
      onClick: handleClick,
      onImageLoad: handleImageLoad
    }, props, {
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.uploadPlaylistThumbnail"
      })
    }))
  });
};